export const MSP_FORM_STATUS = {
  active: 'Activo',
  planned: 'Planificado',
};

export const MSP_FORM_REGISTRY = [
  {
    id: 'HCU_002_CONSULTA_EXTERNA',
    code: 'HCU 002',
    name: 'Consulta Externa',
    status: 'active',
    ownerRole: 'doctor',
    description: 'Anamnesis, antecedentes, signos vitales, examen fisico, diagnosticos CIE-10, plan, evolucion, proxima cita y profesional responsable.',
  },
  {
    id: 'HCU_001_ADMISION',
    code: 'HCU 001',
    name: 'Admision y datos del usuario',
    status: 'planned',
    ownerRole: 'admission',
    description: 'Identificacion, datos demograficos, contacto, cobertura, responsable y datos administrativos del paciente.',
  },
  {
    id: 'CONSENTIMIENTO_TELEMEDICINA',
    code: 'Consentimiento',
    name: 'Consentimiento informado para telemedicina',
    status: 'active',
    ownerRole: 'patient',
    description: 'Aceptacion de atencion remota, tratamiento de datos, limitaciones clinicas y trazabilidad de aceptacion.',
  },
  {
    id: 'RECETA_DIGITAL',
    code: 'Receta',
    name: 'Prescripcion medica digital',
    status: 'planned',
    ownerRole: 'doctor',
    description: 'Medicamentos, dosis, frecuencia, duracion, indicaciones, firma y QR de validacion.',
  },
];

export const HCU_002_MODULES = [
  {
    key: 'patient',
    code: 'A',
    title: 'Datos del establecimiento y paciente',
    requiredFields: [
      ['facilityPatientData.healthFacility', 'Establecimiento requerido'],
      ['facilityPatientData.clinicalHistoryNumber', 'Historia clinica unica requerida'],
      ['facilityPatientData.documentId', 'Documento de identificacion requerido'],
      ['facilityPatientData.fullName', 'Nombre completo requerido'],
    ],
  },
  {
    key: 'reason',
    code: 'B-E',
    title: 'Motivo y enfermedad actual',
    requiredFields: [
      ['consultationReason.description', 'Motivo de consulta requerido'],
      ['currentIllness', 'Enfermedad o problema actual requerido'],
    ],
  },
  {
    key: 'history',
    code: 'C-D',
    title: 'Antecedentes personales y familiares',
    requiredFields: [],
  },
  {
    key: 'vitals',
    code: 'F',
    title: 'Constantes vitales y antropometria',
    requiredFields: [
      ['vitalSigns.date', 'Fecha de signos vitales requerida'],
      ['vitalSigns.time', 'Hora de signos vitales requerida'],
    ],
  },
  {
    key: 'systems',
    code: 'G',
    title: 'Revision de organos y sistemas',
    requiredFields: [],
  },
  {
    key: 'exam',
    code: 'H',
    title: 'Examen fisico',
    requiredFields: [],
  },
  {
    key: 'diagnosis',
    code: 'I',
    title: 'Diagnostico CIE-10',
    requiredFields: [],
    customValidation: 'diagnoses',
  },
  {
    key: 'plan',
    code: 'J-K',
    title: 'Plan y profesional responsable',
    requiredFields: [
      ['responsibleProfessional.date', 'Fecha del profesional requerida'],
      ['responsibleProfessional.time', 'Hora del profesional requerida'],
      ['responsibleProfessional.name', 'Nombre del profesional requerido'],
    ],
  },
  {
    key: 'followUp',
    code: 'L',
    title: 'Evolucion y proxima cita',
    requiredFields: [
      ['clinicalFollowUp.evolution', 'Evolucion de la consulta requerida'],
    ],
    customValidation: 'followUp',
  },
];

export const getNestedValue = (source, path) => path
  .split('.')
  .reduce((current, key) => (current ? current[key] : undefined), source);

export const getModuleCompletion = (form, module) => {
  if (!module.requiredFields.length && !module.customValidation) {
    return { completed: true, total: 0, pending: [] };
  }

  const pending = module.requiredFields
    .filter(([path]) => !String(getNestedValue(form, path) || '').trim())
    .map(([, message]) => message);

  if (module.customValidation === 'diagnoses') {
    const diagnoses = form.diagnoses || [];
    const completedDiagnoses = diagnoses.filter((diagnosis) => (
      String(diagnosis.description || '').trim()
      || String(diagnosis.cie10Code || diagnosis.cie || '').trim()
      || String(diagnosis.observations || '').trim()
    ));
    if (!completedDiagnoses.some((diagnosis) => String(diagnosis.description || '').trim())) {
      pending.push('Registra al menos un diagnostico');
    }
    if (completedDiagnoses.length > 0 && !completedDiagnoses.some((diagnosis) => diagnosis.classification === 'primary')) {
      pending.push('Selecciona un diagnostico principal');
    }
    completedDiagnoses.forEach((diagnosis, index) => {
      if (!String(diagnosis.description || '').trim()) pending.push(`Diagnostico ${index + 1}: descripcion requerida`);
      if (!String(diagnosis.cie10Code || diagnosis.cie || '').trim()) pending.push(`Diagnostico ${index + 1}: codigo CIE-10 requerido`);
    });
  }

  if (module.customValidation === 'followUp' && form.clinicalFollowUp?.requiresNextAppointment) {
    if (!String(form.clinicalFollowUp.nextAppointmentDate || '').trim()) {
      pending.push('Fecha de proxima cita requerida');
    }
    if (!String(form.clinicalFollowUp.nextAppointmentTime || '').trim()) {
      pending.push('Hora de proxima cita requerida');
    }
    if (!String(form.clinicalFollowUp.nextAppointmentReason || '').trim()) {
      pending.push('Motivo de proxima cita requerido');
    }
  }

  return {
    completed: pending.length === 0,
    total: module.requiredFields.length + (module.customValidation ? 1 : 0),
    pending,
  };
};

export const getFormCompletionSummary = (form) => {
  const modules = HCU_002_MODULES.map((module) => ({
    ...module,
    completion: getModuleCompletion(form, module),
  }));
  const completedModules = modules.filter((module) => module.completion.completed).length;

  return {
    modules,
    completedModules,
    totalModules: modules.length,
    percentage: Math.round((completedModules / modules.length) * 100),
  };
};
